export function enableTopPagination(grid, container) {
  const setupTopPagination = () => {
    const footer = container.querySelector('.gridjs-footer');
    if (!footer) return;

    // Create top footer container
    let topFooter = container.querySelector('.gridjs-footer-top');
    if (!topFooter) {
      topFooter = document.createElement('div');
      topFooter.className = 'gridjs-footer gridjs-footer-top';
      // Add some custom styling to separate it from the header/content
      topFooter.style.borderTop = 'none';
      topFooter.style.borderBottom = '1px solid var(--border-color)';
      topFooter.style.marginBottom = '0';
      
      const header = container.querySelector('.gridjs-head');
      const wrapper = container.querySelector('.gridjs-wrapper');
      
      if (header) {
        header.after(topFooter);
      } else if (wrapper) {
        wrapper.before(topFooter);
      } else {
        container.prepend(topFooter);
      }

      // Delegate clicks
      topFooter.addEventListener('click', (e) => {
        const target = e.target.closest('button');
        if (target) {
          e.preventDefault();
          e.stopPropagation();
          
          // Identify button
          const title = target.getAttribute('title');
          const text = target.textContent;
          
          // Find in bottom footer
          const bottomButtons = Array.from(footer.querySelectorAll('button'));
          const match = bottomButtons.find(b => {
             // Match by title (Prev/Next) or text (Page numbers)
             if (title && b.getAttribute('title') === title) return true;
             if (!title && b.textContent === text) return true;
             return false;
          });
          
          if (match) {
            match.click();
          }
        }
      });
    }

    // Function to sync content
    const syncContent = () => {
      topFooter.innerHTML = footer.innerHTML;
    };

    // Initial sync
    syncContent();

    // Observer to keep it in sync
    const observer = new MutationObserver(syncContent);
    observer.observe(footer, { childList: true, subtree: true, attributes: true, characterData: true });
  };

  // Try immediately in case grid is already rendered
  setTimeout(setupTopPagination, 0);
  
  // Also attach to ready event for future renders
  grid.on('ready', setupTopPagination);
}
